<template>
  <div class="w-full h-full relative flex flex-col login">

    <!-- background video -->
    <video data-ui="login-video"
           class="absolute top-0 z-0 left-0 w-full h-full object-cover animate__animated  animate__fadeIn animate__slower"
           autoplay loop muted>
      <source src="../assets/images/login/background.mp4" type="video/mp4"/>
    </video>


    <div class="flex z-10 h-full">

      <div class="h-full flex flex-col">
        <div class="ml-[250px] w-[440px] flex flex-col flex-grow h-full justify-center backdrop-blur p-10 bg-[#ffffffaa] drop-shadow-xl shadow-black">


          <div data-ui="login-grey-background" class=" flex flex-col">

            <!-- TEST BUTTONS -->
<!--
            <div @dragstart="onDragStart" class="bg-red-500" draggable="true">DRAG ME2</div>

            <div @click="testScript" class="bg-green-500 p-2">Try Script</div>

            <div @click="testScript2" class="bg-blue-500 p-2">Try Script 2</div>
-->


            <h1 data-ui="login-headline" class="text-2xl font-bold"><span class="text-black"
                                                                          style="text-shadow: 0px 0px 20px white;">TRADER</span>
              <span class="text-[#a8282e]" style="text-shadow: 0px 0px 20px white;">.</span>
              <br>

              <span class="text-[#bcbaad]" style="text-shadow: 0px 0px 20px white;">BENUTZERANMELDUNG</span>

            </h1>


            <input
                class="rounded p-2 mt-5"
                type="text"
                maxlength="30"
                placeholder="Kunde"
                data-ui="customer"
                autocomplete="off"
                v-model="inputCustomer"
                @keyup.enter="onClickLogin"
            />
            <input
                class="rounded p-2 mt-5"
                type="text"
                name="username"
                autocomplete="username"
                maxlength="30"
                placeholder="Benutzer"
                data-ui=username
                v-model="inputUsername"
                @keyup.enter="onClickLogin"
            />
            <input
                class="rounded p-2 mt-5"
                type="password"
                name="password"
                autocomplete="current-password"
                maxlength="30"
                placeholder="Passwort"
                data-ui="password"
                v-model="inputPassword"
                @keyup.enter="onClickLogin"

            />

            <span class="my-5" data-ui="login-password-recovery">Passwort vergessen?</span>

            <div data-ui="login-wrong-password-message" v-if="wrongPassword">
              Die eingegebenen Benutzerdaten sind nicht korrekt!
            </div>

            <button data-ui="login-button" class="bg-[#a8282e] text-white rounded p-2 "
                    style="margin-top: auto;margin-bottom: 0px;" type="button"

                    v-on:click="onClickLogin">Anmelden
            </button>

            <!--
            <div class="alert" >
              Geben Sie einen gültigen Benutzer und Passwort an.
            </div>
            <div class="alert">
              Ihre Sitzung ist abgelaufen. Bitte loggen Sie sich erneut ein.
            </div>
            -->
          </div>

        </div>
      </div>


      <div class="flex flex-col flex-grow">
        <div class="flex">
          <div class="flex-grow"></div>
          <div class="flex-shrink backdrop-blur  px-5 mr-4">
            <img data-ui="login-logo" src="../assets/images/logo.png">
          </div>
        </div>


        <div v-if="welcomeMessage" class="m-10 p-10 overflow-auto backdrop-blur bg-[#ffffff88]">
          <div class="flex flex-row-reverse">
            <div class="text-2xl hover:text-trader-blue cursor-pointer" @click="hideWelcomeMessage">
              <i class="fa-sharp fa-solid fa-xmark"></i>
            </div>
          </div>

          <div></div>
          <h1 class="text-lg font-bold">Willkommen beim neuen Trader!</h1>

          <p class="text-sm mt-5">
            Wir sind stolz darauf, Ihnen die neueste Version unserer Software präsentieren zu dürfen. <br>
            Der neue Trader wurde entwickelt, um Ihre Arbeit nicht nur zu vereinfachen, sondern auch deutlich
            performanter zu gestalten.<br>
            Dabei haben wir besonderen Wert darauf gelegt, die optische Gestaltung vertraut zu halten, sodass Sie sich
            auch nach dem Update sofort zurechtfinden und die neuen Funktionen mühelos nutzen können.
          </p>

          <p class="text-sm mt-5">
            Erste Schritte:
            <ul class="list-decimal text-sm ml-5">
              <li>Bitte melden Sie sich mit Ihren gewohnten Zugangsdaten an.</li>
              <li>Danach wird bei der ersten Anmeldung nach ihrer E-Mail Adresse gefragt.</li>
              <li>Wir wünschen Ihnen viel Spaß mit dem neuen Trader!</li>
            </ul>
          </p>



        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {ref} from 'vue';
import router from "../router";
import axios from "axios";
import {electron, ScriptLanguage} from "@/electron";

export default {
  name: "Login",
  props: {},
  setup(props) {
    const inputCustomer = ref("selgros");
    const inputUsername = ref("");
    const inputPassword = ref("");

    if (window.location.href.indexOf("192.168.0.20") != -1) {
      inputCustomer.value = "selgros";
      inputUsername.value = "";
      inputPassword.value = "";
    }

    const wrongPassword = ref(false);
    const welcomeMessage = ref(true);

    function sha1(msg) {
      function rotl(n, s) { return n << s | n >>> (32 - s); }
      function toHex(i) {
        return ("00000000" + i.toString(16)).slice(-8);
      }
      // UTF-8 Encoding
      msg = unescape(encodeURIComponent(msg));
      const msgLen = msg.length;
      const words = [];
      for (let i = 0; i < msgLen - 3; i += 4) {
        words.push(
            msg.charCodeAt(i) << 24 |
            msg.charCodeAt(i + 1) << 16 |
            msg.charCodeAt(i + 2) << 8 |
            msg.charCodeAt(i + 3)
        );
      }
      let i = msgLen % 4;
      let tmp = 0;
      if (i === 0) {
        tmp = 0x080000000;
      } else if (i === 1) {
        tmp = msg.charCodeAt(msgLen - 1) << 24 | 0x0800000;
      } else if (i === 2) {
        tmp = msg.charCodeAt(msgLen - 2) << 24 |
            msg.charCodeAt(msgLen - 1) << 16 | 0x08000;
      } else if (i === 3) {
        tmp = msg.charCodeAt(msgLen - 3) << 24 |
            msg.charCodeAt(msgLen - 2) << 16 |
            msg.charCodeAt(msgLen - 1) << 8 | 0x80;
      }
      words.push(tmp);
      while ((words.length % 16) !== 14) words.push(0);
      words.push(msgLen >>> 29);
      words.push((msgLen << 3) & 0x0ffffffff);
      let H0 = 0x67452301;
      let H1 = 0xEFCDAB89;
      let H2 = 0x98BADCFE;
      let H3 = 0x10325476;
      let H4 = 0xC3D2E1F0;
      const W = new Array(80);
      for (let block = 0; block < words.length; block += 16) {
        for (let t = 0; t < 16; t++) W[t] = words[block + t];
        for (let t = 16; t < 80; t++) {
          W[t] = rotl(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
        }
        let A = H0;
        let B = H1;
        let C = H2;
        let D = H3;
        let E = H4;
        for (let t = 0; t < 80; t++) {
          let f, k;
          if (t < 20) { f = (B & C) | (~B & D); k = 0x5A827999; }
          else if (t < 40) { f = B ^ C ^ D; k = 0x6ED9EBA1; }
          else if (t < 60) { f = (B & C) | (B & D) | (C & D); k = 0x8F1BBCDC; }
          else { f = B ^ C ^ D; k = 0xCA62C1D6; }
          const temp = (rotl(A, 5) + f + E + k + W[t]) & 0x0ffffffff;
          E = D;
          D = C;
          C = rotl(B, 30);
          B = A;
          A = temp;
        }
        H0 = (H0 + A) & 0x0ffffffff;
        H1 = (H1 + B) & 0x0ffffffff;
        H2 = (H2 + C) & 0x0ffffffff;
        H3 = (H3 + D) & 0x0ffffffff;
        H4 = (H4 + E) & 0x0ffffffff;
      }
      return (toHex(H0) + toHex(H1) + toHex(H2) + toHex(H3) + toHex(H4)).toLowerCase();
    }

    const onClickLogin = async () => {
      // Passwort hashen0
      const hashedPassword = await sha1(inputPassword.value);

      axios.post('/api/v3/login', {
        client: inputCustomer.value,
        username: inputUsername.value,
        password: inputPassword.value
      }).then((response) => {
        console.log(response?.data);

        if(response?.data === "noaccess") {
          wrongPassword.value = true;
          router.push('/noaccess');
        } else {
          wrongPassword.value = false;
          router.push('/user/login');
        }


        wrongPassword.value = false;

        // Neuen User-Datensatz erstellen
        let newUser = {
          client: inputCustomer.value,
          username: inputUsername.value,
          password: hashedPassword
        };
        let users = JSON.parse(localStorage.getItem('users') || '[]');
        const userExists = users.some(
            user => user.username === newUser.username && user.client === newUser.client
        );

        console.log("User exists: ", userExists);
        if (!userExists) {
          users.push(newUser);
        }
        // Speichern
        localStorage.setItem('users', JSON.stringify(users));
        router.push('/user/login');
      }).catch((error) => {
        wrongPassword.value = true;
      });
    }

    const hideWelcomeMessage = () => {
      welcomeMessage.value = false;
    }

    const onDragStart = (event) => {
      event.preventDefault(); // Standardverhalten verhindern
      const filePath = '/Volumes/FegroFoodBilder/*Allgemeine_Teile/AdobeStock_166700577.jpeg'; //'/Users/michaelhoelzl/Desktop/test.png'; // Pfad anpassen
      window?.electronAPI.startDrag(filePath); // Drag-Aktion starten
    }

    const testCommand = () => {
      /*
      const script = `do shell script "ls /Users/michaelhoelzl/Desktop/Neuer\\\\ Ordner/" with administrator privileges`;
      let appleScript = `osascript -e '${script}'`;

      // Die Antwort vom Main-Prozess empfangen
// Empfangen der Antwort vom Main-Prozess
      window.electronAPI.receiveFromMain('commandResponse', (result) => {
        if (result.success) {
          
          
        } else {
          console.error('Fehler beim Ausführen des Kommandos:');
          console.error(result.output);
        }
      });

      window?.electronAPI.runCommand(appleScript); // Drag-Aktion starten
      */
    }


    /*
    window?.electronAPI.evalInElectronResult ((result) => {
      
    });
    */

    const testScript2 = async () => {
      //const script = `do shell script "ls /Users/michaelhoelzl/Downloads/" with administrator privileges`;

      const filePath = "/Users/michaelhoelzl/Projects/Phoenix/data/selgros/packages/indesign/icon.png";
      const script = `set filePath to POSIX file "${filePath}"
        tell application "Finder"
            activate
            reveal filePath
        end tell`;

      const [result, err] = await electron.runScript(ScriptLanguage.AppleScript, script, "");

      if(err) {
        console.error(err);
      } else {
        
      }



    }

    const testScript = async () => {
  


      const script = `

      const url = "https://live.staticflickr.com/4231/34588100443_3e2bb7df8b_o_d.jpg"
      const filePath = app.getPath('home')+"/test123123.jpg"


        downloadFile(url, filePath)


        `;

      const [result, err] = await electron.runScript(ScriptLanguage.JavaScript, script);

      if(err) {
        console.error(err);
      } else {
        
      }


/*
      const [test, err2] = await electron.runScript(ScriptLanguage.AppleScript, `
set wallpaperPath to "/Users/michaelhoelzl/Downloads/test.jpg"
do shell script "osascript -e 'tell application \\"System Events\\" to set picture of every desktop to \\"" & wallpaperPath & "\\"'" with administrator privileges
`);

      
      
*/



      /*
       window.electronAPI.receiveFromMain('commandResponse', (result) => {
         if (result.success) {
           
           
         } else {
           console.error('Fehler beim Ausführen des Kommandos:');
           console.error(result.output);
         }
       });


       




       let ret = window?.electronAPI.runJavaScript(script);
       



       window?.electronAPI.runJavaScript(`
         const fs = require('fs');
         const path = require('path');

         const directoryPath = '/Users/michaelhoelzl/Projects/Phoenix/data/selgros/packages/indesign/';

         fs.readdir(directoryPath, (err, files) => {
           if (err) {
             return console.error('Fehler beim Lesen des Verzeichnisses:', err);
           }
           files.forEach(file => {
             const filePath = path.join(directoryPath, file);
             fs.stat(filePath, (err, stats) => {
               if (err) {
                 return console.error('Fehler beim Abrufen der Dateiinfo:', err);
               }
               if (stats.isFile()) {
                 
               }
             });
           });
         });
       `);
       */
    }

    return {
      onClickLogin,
      inputCustomer,
      inputUsername,
      inputPassword,
      wrongPassword,
      welcomeMessage,
      hideWelcomeMessage,
      onDragStart,
      testCommand,
      testScript,
      testScript2,
    };
  },
  created() {
  }
}
</script>

<style scoped>


</style>
